import React from 'react'
import classNames from 'classnames'
import ctaArrow from  '../../images/cta-arrow.svg'
import ctaPlay from  '../../images/cta-play.svg'
import './SectionContent.css'

const gtag_SAFE = (...args) => {
  try {
    window.gtag(...args);
  } catch (thrown) {
    console.error(thrown);
  }
};
let hasAnimated = false;


const SectionContent = ({sectionObj, isMobile, isCurrentSlide, sectionIndex, onCTAClick}) => {
  const obj = sectionObj
  const hasFooterText = obj.finePrint || obj.ctaText
  const classNamesList = ["text-container"];
  if (!isMobile) {
    if (sectionIndex === 0 && !hasAnimated) {
      classNamesList.push("first-text")
      hasAnimated = true;
    }
    if (isCurrentSlide) {
      classNamesList.push("animate-text-container-in")
    } else {
      classNamesList.push("animate-text-container-out")
    }
  }

  const handleCTAClick = (id) => () => {
      // eslint-disable-next-line no-undef
      gtag_SAFE('event', 'cta_click', {
        event_category: 'engagement',
        event_label: id
      });
    }

  return (
    <div className={classNames({
      "mobile-section-content": isMobile,
      "desktop-section-content": !isMobile
    },  "show-on-scroll"

    )}>
      <div className={classNames(classNamesList)}>
        <div
          className={classNames("typography", "heading", {
            "capped-width-text": !!obj.subtitle, //if there is a subtitle, makea  max width
          })}
          // className={`typography heading ${obj.subtitle }`}
        >{obj.title}</div>
        {obj.subtitle && <div
          // className={"typography subtitle"}
          className={classNames("typography", "subtitle", {
            "capped-width-subtitle": !!obj.subtitle, //if there is a subtitle, makea  max width
          })}
                         >
          {obj.subtitle}</div>}
      </div>
      {hasFooterText && ( //NOTE in desktop this is outside of section-content div, check bxo options to see whats right
        <div className={"section-footer-container"}>
          {obj.finePrint &&
            <div className="typography fine-print">
              {obj.finePrint}
            </div>
          }
          {obj.ctaText && !!isMobile && //footer cta is handled in APP.js for desktop
            <a
              className={classNames("typography", "footer-cta", {
                "footer-cta-fixed": !isMobile
              })}
              target="_blank"
              rel="noopener noreferrer"
              href={obj.ctaUrl}
              onClick={onCTAClick}
            >
              {obj.ctaText} {obj.showPlayButton ? <img src={ctaPlay} alt=">" className="cta-play" /> : <img src={ctaArrow} alt=">" className="cta-arrow" />}
            </a>
          }
        </div>
      )}

    </div>
  )
}

export default SectionContent
